// extracted by mini-css-extract-plugin
export var fadeIn = "_em-1";
export var modalContent = "_em-3";
export var overlay = "_em-0";
export var popoverContent = "_em-2";
export var results = "_em-5";
export var searchInputWrapper = "_em-4";